var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 89,
    viewBox: "0 0 81 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5.6C22.6 8.5 19.2 11 20 11C23 11 35.6 17.8 41.1 22.3C44.1 24.8 48.4 29.3 50.5 32.4C54.3 37.9 54.4 38 59.1 38C64.7 38 71.8 40.2 77.2 43.6L81 46V35.5C81 28.3 80.5 24 79.6 22.2C78.6 20.3 72.9 16.5 61.2 9.7C40.5 -2.2 40.4 -2.2 27.5 5.6Z",
    fill: "#2696BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20002 18C0.800021 21.3 2.1004e-05 24.7 2.1004e-05 44.7C2.1004e-05 67.5 -0.0999786 67.4 13.5 75.2C19 78.4 23.7 81 24 81C25.4 81 23.6 69.3 21.9 67.1C17.9 62.1 21.2 53 27 53C28.2 53 31.2 50.9 33.9 48.2C36.5 45.6 40.5 42.6 42.8 41.6C45.1 40.5 47 39.4 47 39.1C47 37.4 37.4 27.8 32.4 24.5C26.7 20.7 15.2 16.1 11.5 16C10.4 16 8.00002 16.9 6.20002 18Z",
    fill: "#2696BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 48.5998C60.9 53.3998 61.4 56.7998 61.4 66.5998L61.5 78.7998L67.4 75.5998C70.6 73.8998 75 70.8998 77.1 68.8998C80.8 65.4998 81 64.9998 81 59.3998C81 53.8998 80.7 53.0998 77.8 50.2998C73.2 45.9998 68.7 43.8998 62.4 43.2998L57 42.6998L59.2 48.5998Z",
    fill: "#2696BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4 45.9999C42.2 47.0999 38.9 49.4999 37.1 51.3999C34.3 54.2999 34 55.0999 34.9 56.7999C37.6 61.8999 34.2 69.9999 29.4 69.9999C28 69.9999 27.8 70.6999 28.4 74.8999C29.5 82.8999 30.8 85.4999 34.6 87.2999C39.5 89.6999 43.4 89.3999 48.5 86.3999C52.5 84.0999 53 83.3999 54.1 78.1999C55.7 70.1999 54.8 56.7999 52.1 49.6999C50.9 46.5999 49.6 43.9999 49.2 43.9999C48.8 43.9999 46.7 44.8999 44.4 45.9999Z",
    fill: "#2696BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.0b5054b82ba7cbc54990cbb6ce699159.svg";
export { ForwardRef as ReactComponent };